import { render, staticRenderFns } from "./FormDisplayTitle.vue?vue&type=template&id=70695040&scoped=true"
import script from "./FormDisplayTitle.vue?vue&type=script&setup=true&lang=js"
export * from "./FormDisplayTitle.vue?vue&type=script&setup=true&lang=js"
import style0 from "./FormDisplayTitle.vue?vue&type=style&index=0&id=70695040&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70695040",
  null
  
)

export default component.exports